<template>
    <!-- show-multi-search -->
    <crm-content>
        <template v-slot:actionLeft>
            <vx-action-icon icon="MenuIcon" class="mr-4" @click="toggleSideBar" />
            <h5 class="line-height-inherit">{{ title }}</h5>
        </template>
        <!-- <practices-table /> -->
        <template v-slot:actionRight>
            <vx-action-icon
                isButton
                class="clear-button"
                color="primary"
                icon="PlusIcon"
                tooltip="New Practice"
                @click="showEditor = true"
            />
        </template>

        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="vx-row mb-2">
                    <div class="vx-col w-full"></div>
                </div>
                <vx-card>
                    <practices-table ref="practices_table" @input="openPractice" />
                </vx-card>
            </div>
        </div>
        <practice-editor
            v-if="showEditor"
            v-model="newPractice"
            :active.sync="showEditor"
            @close="showEditor = false"
        />
    </crm-content>
</template>

<script>
import PracticesTable from './PracticesTable.vue'
import CrmContent from '../../crm/components/CrmContent.vue'
import PracticeEditor from './PracticeEditor.vue'

export default {
    name: 'practices-main',
    components: {
        CrmContent,
        PracticesTable,
        PracticeEditor
    },
    data() {
        return {
            title: 'Practices',
            showEditor: false,
            newPractice: null
        }
    },
    watch: {
        showEditor: {
            handler(val) {
                if (!val) {
                    this.close()
                }
            }
        }
    },
    methods: {
        openPractice(selectedPractice) {
            this.$router.push({
                name: 'practice-details',
                params: { practiceId: selectedPractice.id }
            })
            // console.log(this.$router)
        },
        close() {
            this.newPractice = null
            this.$refs['practices_table'].$refs.lineTable.reset()
        }
    }
}
</script>
<style scoped>
.clear-button {
    background-color: rgb(248, 148, 6);
}
</style>
